import Geocode from 'react-geocode';

import { getIsoCodeCurrentLocale } from 'common/utils/helpers/multiregion';

import {
    FETCH_GEOCODE_POINT,
    FETCH_GEOCODE_POINT_FAILURE,
    FETCH_GEOCODE_POINT_SUCCESS,
} from '../actionTypes';
import { getCity, getState, getCountry } from '../helpers';
import { createProjectModalActions } from '../reducer';

export default (lat, lng) => (dispatch) => {
    Geocode.setApiKey(import.meta.env.VITE_GOOGLE_MAPS_KEY);
    Geocode.setLanguage(getIsoCodeCurrentLocale());
    Geocode.setRegion('mx');

    dispatch(createProjectModalActions[FETCH_GEOCODE_POINT]());

    return Geocode.fromLatLng(lat, lng).then(
        (response) => {
            dispatch(
                createProjectModalActions[FETCH_GEOCODE_POINT_SUCCESS]({
                    address: response.results[0]?.formatted_address,
                    city: getCity(response.results[0]?.address_components),
                    state: getState(response.results[0]?.address_components),
                    country: getCountry(
                        response.results[0]?.address_components,
                    ),
                }),
            );
        },
        (error) =>
            dispatch(
                createProjectModalActions[FETCH_GEOCODE_POINT_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
    );
};
